module.exports = __webpack_public_path__ + "static/media/slankamen3.8db8817b.png";